import React, { useState } from 'react'
import { Marker } from 'react-map-gl'
import { faMapMarker } from '@fortawesome/free-solid-svg-icons'

import Icon from '../../atoms/Icon'

import Button from '../../atoms/Map/ApartmentButton'
import Tooltip from '../../atoms/Map/ApartmentTooltip'

export default ({ apartment, onClick, highlight }) => {
  const [show, setShow] = useState()

  const events = {
    onFocus: () => setShow(true),
    onBlur: () => setShow(),
    onMouseEnter: () => setShow(true),
    onMouseLeave: () => setShow(),
    onClick: () => {
      setShow(false)
      onClick()
    },
  }

  return (
    <>
      <Marker latitude={apartment.coordinates.lat} longitude={apartment.coordinates.lng}>
        <Button {...events} highlight={highlight}>
          <Icon icon={faMapMarker} size='lg' />
        </Button>
      </Marker>
      {show || highlight ? (
        <Tooltip
          latitude={apartment.coordinates.lat}
          longitude={apartment.coordinates.lng}
          onClose={() => setShow()}
        >
          {apartment.name}
        </Tooltip>
      ) : null}
    </>
  )
}
